import { render, staticRenderFns } from "./intimateRule.vue?vue&type=template&id=2ae1ea1d&scoped=true"
import script from "./intimateRule.vue?vue&type=script&lang=js"
export * from "./intimateRule.vue?vue&type=script&lang=js"
import style0 from "./intimateRule.vue?vue&type=style&index=0&id=2ae1ea1d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1ea1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae1ea1d')) {
      api.createRecord('2ae1ea1d', component.options)
    } else {
      api.reload('2ae1ea1d', component.options)
    }
    module.hot.accept("./intimateRule.vue?vue&type=template&id=2ae1ea1d&scoped=true", function () {
      api.rerender('2ae1ea1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/FriendshipLevel/intimateRule.vue"
export default component.exports